export default "<div fxLayout=\"column\">\n    <router-outlet></router-outlet>\n</div>\n";